import ModalStore from '@/stores/modal/modal';
import { NotificationStore } from '@/stores/notification/notification';

export class ReportModal {
    selectedFlag: number | null = null;
    successMessage: string = window.translation['report_submitted'];

    handleResponse(event: CustomEvent) {
        const status = event.detail?.xhr?.status;
        if (status && status >= 200 && status < 300) {
            const toast = Alpine.store('notification') as NotificationStore;
            toast.create({ type: 'success', message: this.successMessage });
        }

        const modalStore = Alpine.store('modal') as ModalStore;
        modalStore.closeModal('reportModal');
    }
}
